import { useCallback } from "react";
import { PaymentMethods } from "../PaymentMethods";
import { useViewPaymentMethods } from "./ViewPaymentMethods.service";
import * as ViewMoreSubs from "./ViewPaymentMethods.styles";
import { ViewPaymentMethodsProps } from "./ViewPaymentMethods.types";

const ViewPaymentMethods = ({
  maxNumberInstallments,
  discountPercentage,
  salePrice,
  spotPrice,
  isMobile = false,
}: ViewPaymentMethodsProps) => {
  const {
    paymentMethodsData,
    isViewMoreModalOpen,
    setIsViewMorePaymentMethodsOpen,
  } = useViewPaymentMethods({
    discountPercentage,
    maxNumberInstallments,
    salePrice,
    spotPrice,
  });

  const viewMoreTextCallback = useCallback(() => {
    if (isMobile) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
    setIsViewMorePaymentMethodsOpen(true);
  }, [isMobile, setIsViewMorePaymentMethodsOpen]);

  return (
    <>
      <ViewMoreSubs.Container>
        <ViewMoreSubs.Text onClick={viewMoreTextCallback}>
          ver opções de pagamento
        </ViewMoreSubs.Text>
      </ViewMoreSubs.Container>
      {!isMobile && (
        <PaymentMethods
          data={paymentMethodsData}
          isOpen={isViewMoreModalOpen}
          onCloseModal={() => setIsViewMorePaymentMethodsOpen(false)}
        />
      )}
    </>
  );
};

export { ViewPaymentMethods };
